// extracted by mini-css-extract-plugin
module.exports = {"avatar":"OurExperts_avatar__nsYT1","avatarContainer":"OurExperts_avatarContainer__g1gXJ"};